module.exports = __webpack_public_path__ + "img/img0102.20412b3c.png";